import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import styled from "styled-components";
import { Link } from "react-router-dom";
const Lnk = styled(Link)`
  display: ${(props) => props.display || "flex"};
  justify-content: ${(props) => props.justifyContent || "center"};
  align-items: ${(props) => props.alignItems || "center"};
  text-decoration: none;
  color: ${(props) =>
    props.color
      ? props.color
      : props.active
      ? props.theme.primary
      : props.theme.disable};
  border-radius: ${(props) => props.borderRdius || props.theme.borderRadius};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  font-size: ${(props) => props.fontSize || "1em"};
  background-color: ${(props) => props.backgroundColor || "transparent"};
  font-weight: ${(props) => props.fontWeight || props.theme.fontWeight};
  font-size: ${(props) => props.fontSize || props.theme.fontSize};
  padding: ${(props) => props.padding || "0.2em 0.8em 0.2em 0.8em"};
  border-radius: ${(props) => props.borderRadius || 0};
  /* border : 1px solid white ; */
  cursor: ${(props) => (props.disabled ? "no-drop" : "pointer")};
  &:hover {
    color: ${(props) =>
      props.hoverColor
        ? props.hoverColor
        : props.active
        ? "white"
        : props.theme.disable};
  }
`;
const LnkForce = styled("a")`
  display: ${(props) => props.display || "flex"};
  justify-content: ${(props) => props.justifyContent || "center"};
  align-items: ${(props) => props.alignItems || "center"};
  text-decoration: none;
  color: ${(props) =>
    props.color
      ? props.color
      : props.active
      ? props.theme.primary
      : props.theme.disable};
  border-radius: ${(props) => props.borderRdius || props.theme.borderRadius};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  font-size: ${(props) => props.fontSize || "1em"};
  background-color: ${(props) => props.backgroundColor || "transparent"};
  font-weight: ${(props) => props.fontWeight || props.theme.fontWeight};
  font-size: ${(props) => props.fontSize || props.theme.fontSize};
  padding: ${(props) => props.padding || "0.2em 0.8em 0.2em 0.8em"};
  border-radius: ${(props) => props.borderRadius || 0};
  /* border : 1px solid white ; */
  cursor: ${(props) => (props.disabled ? "no-drop" : "pointer")};
  &:hover {
    color: ${(props) =>
      props.hoverColor
        ? props.hoverColor
        : props.active
        ? "white"
        : props.theme.disable};
  }
`;
const StyledLink = (props) => {
  const theme = useContext(ThemeContext);
  let prp = {};
  if (props.newTab === true) {
    prp.target = "_blank";
  }
  let Cmp = Lnk;
  if (props.force) {
    Cmp = LnkForce;
    prp.href = props.to;
  } else {
    prp.to = props.to;
  }
  return (
    <Cmp {...props} className={props.className} theme={theme} {...prp}>
      {props.children}
    </Cmp>
  );
};

export default StyledLink;
